import { Box, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { NoteAdd, UploadFile } from "@mui/icons-material";
import styled from "styled-components";
import useFetching from "../../utils/Fetching";

const AddDocumentDialog = ({ buttonText, onSubmit }) => {
  const { adminUploadPDF } = useFetching();

  const [open, setOpen] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileData, setFileData] = useState(undefined);
  const [uploadName, setUploadName] = useState("");
  const [fileError, setFileError] = useState(false);

  const resetForm = () => {
    setFileName("");
    setFileData(undefined);
    setUploadName("");
    setFileError(false);
  };

  const handleClickOpen = () => {
    resetForm();
    setOpen(true);
  };

  const handleSubmit = async () => {
    if (fileData === undefined) {
      setFileError(true);
    }

    if (fileName && fileData) {
      const name = fileName.endsWith(".pdf") ? fileName : fileName + ".pdf";
      const formData = new FormData();
      formData.append("fileName", name);
      formData.append("fileData", fileData);
      formData.append("uploadName", uploadName);
      await adminUploadPDF(formData);
      onSubmit();
      setOpen(false);
    }
  };

  const handleAbort = () => {
    setOpen(false);
  };

  const handleFileNameChange = (event) => {
    setFileName(event.target.value);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileData(file);
    setUploadName(file.name);
    setFileError(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClickOpen}
        startIcon={<NoteAdd />}
      >
        {buttonText}
      </Button>
      <Dialog
        open={open}
        onClose={handleAbort}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Dokument hinzufügen</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <Box component="form" noValidate>
              <Typography gutterBottom>
                Definieren Sie den Dateinamen. (Nicht Upload-Name)
              </Typography>
              <TextField
                required
                id="add-document-file-name"
                label="Dateiname"
                value={fileName}
                onChange={handleFileNameChange}
                error={fileName === ""}
                helperText={"Pflichtfeld"}
              />
              <Typography gutterBottom sx={{ mt: 2 }}>
                Datei hochladen:
              </Typography>
              <Box>
                <Button
                  component="label"
                  role={undefined}
                  variant="outlined"
                  startIcon={<UploadFile />}
                >
                  Hochladen
                  <VisuallyHiddenInput
                    type="file"
                    accept=".pdf"
                    onChange={handleFileChange}
                  />
                </Button>
                {uploadName && (
                  <Typography component="span" sx={{ ml: 2 }}>
                    {uploadName}
                  </Typography>
                )}
              </Box>
              {fileError && (
                <Typography color="error">Laden Sie eine Datei hoch</Typography>
              )}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAbort}>Abbrechen</Button>
          <Button onClick={handleSubmit} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default AddDocumentDialog;
